import { render, staticRenderFns } from "./ReservaCartaoDetalhe.vue?vue&type=template&id=38ef23a4&scoped=true&"
import script from "./ReservaCartaoDetalhe.vue?vue&type=script&lang=js&"
export * from "./ReservaCartaoDetalhe.vue?vue&type=script&lang=js&"
import style0 from "./ReservaCartaoDetalhe.vue?vue&type=style&index=0&id=38ef23a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ef23a4",
  null
  
)

export default component.exports